import { styled } from '@mui/material';

export const StyledInput = styled('input')`
    display: none;
`;
